const timePeriodSelectionOptions = [  
  { value: '-4', label: '4 Months',text_value:'Time Period: '},
  { value: '-6', label: '6 Months',text_value:'Time Period: '},
  { value: '-1', label: '1 Year',text_value:'Time Period: '},
  { value: '-0', label: 'From Start',text_value:'Time Period: '},
]

export default timePeriodSelectionOptions
